module.exports = __webpack_public_path__ + "img/ideation-05-bg-brandvideo-overlay.d9537b32.png";